import { render } from "./FormTinyEditor.vue?vue&type=template&id=f8b22288&scoped=true"
import script from "./FormTinyEditor.vue?vue&type=script&lang=js"
export * from "./FormTinyEditor.vue?vue&type=script&lang=js"

import "./FormTinyEditor.vue?vue&type=style&index=0&id=f8b22288&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b22288"]])

export default __exports__